import { ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";

import BaseEntitySearchAutocomplete, {
  BaseEntitySearchAutocompleteInheritableProps,
} from "@/common/components/Entity/components/BaseEntitySearchAutocomplete";
import AppIcon from "@/common/components/Icons/AppIcon";
import { StringHelper } from "@/common/helpers/string";
import { AutocompleteOptionType, BaseAutocompleteOption } from "@/common/ts/autocomplete";
import { apiClient } from "@/core/api/ApiClient";
import { VehicleModelDto, VehicleModelGetPaginatedDto } from "@/core/api/generated/v1";

export interface VehicleModelsAutocompleteProps extends BaseEntitySearchAutocompleteInheritableProps<VehicleModelDto> {
  searchFilters?: Partial<Omit<VehicleModelGetPaginatedDto, "search" | "includeIds">>;
}

export type VehicleModelAutocompleteOption = BaseAutocompleteOption<VehicleModelDto>;

export const vehicleModelToOption = (data: VehicleModelDto): VehicleModelAutocompleteOption => ({
  id: data.id!,
  title: StringHelper.join([data.name], ", ", {
    skipEmpty: true,
  }),
  optionType: AutocompleteOptionType.Normal,
  data: data,
});

export default function VehicleModelAutocomplete({
  searchFilters,
  isPreload = true,
  ...otherProps
}: VehicleModelsAutocompleteProps) {
  return (
    <BaseEntitySearchAutocomplete
      sx={{ minWidth: 200 }}
      entityToOption={vehicleModelToOption}
      isPreload={isPreload}
      request={{
        requestFunc: apiClient.vehicleModelsApi.apiV1ReferenceDataVehiclesModelsGetPost,
        limit: 25,
        parameters: {
          vehicleModelGetPaginatedDto: {
            ...searchFilters,
          },
        },
        combineParameters: (params, newParams) => ({
          ...params,
          vehicleModelGetPaginatedDto: {
            ...params.vehicleModelGetPaginatedDto,
            ...newParams,
          },
        }),
        deps: [searchFilters],
      }}
      label='Model'
      placeholder='Search for model...'
      renderOption={(props, option) => {
        return (
          <ListItem {...props} key={option.id}>
            <ListItemIcon>
              <AppIcon of='vehicle' />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography component='div' variant='body1'>
                  {option.title}
                </Typography>
              }
            />
          </ListItem>
        );
      }}
      {...otherProps}
    />
  );
}
